module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [(_vm.isLoading) ? _c('ButtonLoader') : _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a211724","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/button/Button.vue
// module id = c76fdfcf4d9277c3a920
// module chunks = 89